import { render } from "./BaseSimpleFilter.vue?vue&type=template&id=8073db52&scoped=true&ts=true"
import script from "./BaseSimpleFilter.vue?vue&type=script&lang=ts"
export * from "./BaseSimpleFilter.vue?vue&type=script&lang=ts"

import "./BaseSimpleFilter.vue?vue&type=style&index=0&id=8073db52&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8073db52"]])

export default __exports__